import { StockEmployee } from '../models';
import api from './apiClient';

export const fetchStockEmployees = async (payload?: any) => {
  const response = await api.post('/stock-employees/table', payload);
  return response.data;
};

export const fetchStockEmployeeByName = (name: string) => {
  return api.get(`/stock-employee/${name}`);
};

export const addNewStockEmployee = (employee: StockEmployee) => {
  return api.post<StockEmployee>('/stock-employee', employee);
};

export const updateExistingStockEmployee = (employee: StockEmployee) => {
  return api.put<StockEmployee>(`/stock-employee/${employee.name}`, employee);
};

export default {
  fetchStockEmployees,
  fetchStockEmployeeByName,
  addNewStockEmployee,
  updateExistingStockEmployee,
};
